module.exports = __webpack_public_path__ + "img/ke.abaf8bd8.svg";